import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-45e70cf0"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "d-flex flex-column p-4 tab-data"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-row justify-content-between" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-column title-text" }, " Date "),
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-column title-text" }, " Route ")
], -1))
const _hoisted_3 = { class: "d-flex flex-column" }
const _hoisted_4 = { class: "d-flex flex-row recap-error" }
const _hoisted_5 = { class: "d-flex flex-column normal-text" }
const _hoisted_6 = { class: "d-flex flex-row normal-text align-items-center" }
const _hoisted_7 = {
  key: 0,
  class: "d-flex mx-2"
}
const _hoisted_8 = {
  key: 1,
  class: "d-flex mx-2"
}
const _hoisted_9 = ["onClick"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "M3 9.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z" }, null, -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = {
  key: 0,
  class: "d-flex flex-row"
}
const _hoisted_13 = { class: "error" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.display = !_ctx.display)),
      class: "d-flex flex-row pt-4 title"
    }, " Historique erreurs "),
    (_ctx.display)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _hoisted_2,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.history, (h) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "d-flex flex-row",
              key: h.date
            }, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, _toDisplayString(h.date), 1),
                  _createElementVNode("div", _hoisted_6, [
                    (h.route)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(h.route), 1))
                      : (h.statusCode)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(h.message), 1))
                        : _createCommentVNode("", true),
                    (_openBlock(), _createElementBlock("svg", {
                      onClick: ($event: any) => (h.displayDetails = !h.displayDetails),
                      xmlns: "http://www.w3.org/2000/svg",
                      width: "16",
                      height: "16",
                      fill: "currentColor",
                      class: "bi bi-three-dots details-error-btn",
                      viewBox: "0 0 16 16"
                    }, _hoisted_11, 8, _hoisted_9))
                  ])
                ]),
                (h.displayDetails)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                      _createElementVNode("pre", _hoisted_13, "                        " + _toDisplayString(JSON.parse(JSON.stringify(h))) + "\n                    ", 1)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ], 64))
}